import React from 'react'
import MaterialSymbol from '../material-symbol'

const Today = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="today" {...props} />
))

Today.displayName = 'Today'

export default Today
